import { createBrowserRouter, RouterProvider, useRouteError } from 'react-router'

import ErrorView from '../views/ErrorView'
import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import routes from './routes'

const RouteErrorBoundary = () => {
  const error = useRouteError()
  return <ErrorView error={error instanceof Error ? error : new Error(String(error))} />
}

const router = createBrowserRouter(
  routes.map(({ path, component: Component, isPublic, restricted }) => ({
    path,
    element: isPublic ? (
      <PublicRoute component={Component} restricted={restricted} />
    ) : (
      <PrivateRoute>
        <Component />
      </PrivateRoute>
    ),
    errorElement: <RouteErrorBoundary />
  }))
)

const Router = () => {
  return <RouterProvider router={router} />
}

export default Router
